import { 
	ADD_PROMO,
	DE_ACTIVATE_PROMO,
	SET_PROMO
} from './actions/types';

const defaultState = {
	loading: true,
	data:[]
}

export const promoPaymentReducer = (state = defaultState, action) => {
	switch(action.type){

		case ADD_PROMO:
			return {
				loading:false,
				data: [ ...state.data, action.promo]
			}

		case SET_PROMO:
			return {
				loading: false,
				data: action.promotions
			}
		
		case DE_ACTIVATE_PROMO:
			return {
				loading: false,
				data: state.data.map(
					promo => {
						
						if( promo._id === action.promo._id ){
							promo.active = false;
						} 

						return promo
					}
				)
			}

		default: 
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/components/promo/payment/reducer.js